module.exports = __webpack_public_path__ + "img/back-money.1af2fd39.svg";